/**
 * Utility functions for building Temporal UI URLs
 */

/**
 * Build a URL to view a workflow in the Temporal UI.
 *
 * @param workflowId - The workflow ID from Temporal
 * @param runId - The run ID from Temporal
 * @returns Full URL to the workflow history page in Temporal UI
 */
export const buildTemporalWorkflowUrl = (
  workflowId: string,
  runId: string
): string => {
  const isLocal =
    import.meta.env.VITE_APP_ENVIRONMENT === 'local' ||
    window.location.hostname === 'localhost';

  const encodedWorkflowId = encodeURIComponent(workflowId);

  if (isLocal) {
    return `http://localhost:7234/namespaces/default/workflows/${encodedWorkflowId}/${runId}/history`;
  }

  // Production
  return `https://cloud.temporal.io/namespaces/prod-namespace.rpti6/workflows/${encodedWorkflowId}/${runId}/history`;
};

/**
 * Build a URL to view a schedule in the Temporal UI.
 *
 * @param scheduleId - The Temporal schedule ID
 * @returns Full URL to the schedule page in Temporal UI
 */
export const buildTemporalScheduleUrl = (scheduleId: string): string => {
  const isLocal =
    import.meta.env.VITE_APP_ENVIRONMENT === 'local' ||
    window.location.hostname === 'localhost';

  const encodedScheduleId = encodeURIComponent(scheduleId);

  if (isLocal) {
    return `http://localhost:7234/namespaces/default/schedules/${encodedScheduleId}`;
  }

  return `https://cloud.temporal.io/namespaces/prod-namespace.rpti6/schedules/${encodedScheduleId}`;
};
